export default function DisableConsoleLog() {
    // disable the console.log function on the live env
    if (process.env.REACT_APP_DEPLOY_ENV === "live") {
        console.log = () => {}
    }
}